const SOCIAL_AUTH_RESUME_PATH_KEY = 'social_auth_resume_path'

export function saveSocialAuthResumePath(path) {
  if (!path) {
    return
  }

  sessionStorage.setItem(SOCIAL_AUTH_RESUME_PATH_KEY, path)
}

export function getSocialAuthRedirectState() {
  const linkAfterAuth = sessionStorage.getItem('linkAfterAuth')
  const resumePath = sessionStorage.getItem(SOCIAL_AUTH_RESUME_PATH_KEY)
  const redirectPath = linkAfterAuth || resumePath || null

  return { redirectPath, resumePath }
}

// После возврата из соцсети нам нужны две вещи:
// исходный путь, куда возвращаться для продолжения регистрации,
// и финальный redirect path после успешного auth/registration.
export function consumeSocialAuthRedirectState({ preserveLinkAfterAuth = false } = {}) {
  const state = getSocialAuthRedirectState()

  sessionStorage.removeItem(SOCIAL_AUTH_RESUME_PATH_KEY)
  if (!preserveLinkAfterAuth) {
    sessionStorage.removeItem('linkAfterAuth')
  }

  return state
}
